import type { ColumnWidth, SpacingObject, SpacingToken, WidthObject } from './types';

export const isSpacingObject = (
  spacing: SpacingToken | SpacingObject | undefined,
): spacing is SpacingObject => {
  return typeof spacing === 'object' && spacing?.desktop !== undefined;
};

export const isWidthObject = (
  spacing: ColumnWidth | WidthObject | undefined,
): spacing is WidthObject => {
  return typeof spacing === 'object' && spacing?.desktop !== undefined;
};
